import zod from 'zod';

export const SmartSearchFacialSchemas = {
    SmartSearchFacial: zod.object({}),
} as const;
